<template>
  <div class="news-warpper page-width-warpper">
    <Title title="企业动态" en="INFORMATION" align="left" />
    <div class="news-list">
      <template v-if="!isMobile">
        <div
          class="item"
          v-for="(item, i) in leftList"
          :key="i"
          @click="toDetail(item.id)"
        >
          <img class="image" :src="item.icon" />
          <div class="item-content">
            <div class="name">{{ item.title }}</div>
            <div class="time">
              {{ item.updateTime && item.updateTime.split(" ")[0] }}
            </div>
            <p>{{ item.summary }}</p>
            <div class="btn">查看详情</div>
          </div>
        </div></template
      >
      <div class="item list">
        <div
          class="item-content"
          v-for="(item, i) in rightList"
          :key="i"
          @click="toDetail(item.id)"
        >
          <div class="name">{{ item.title }}</div>
          <div class="time">
            {{ item.updateTime && item.updateTime.split(" ")[0] }}
          </div>
          <p>{{ item.summary }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "./Title.vue";
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Title,
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    leftList() {
      return this.list.filter((f, i) => i < 2);
    },
    rightList() {
      return this.list.filter((f, i) => i >= 2 && i < 6);
    },
  },
  methods: {
    toDetail(id) {
      this.$router.push(`/newsDetail?id=${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css

.news-warpper {
  padding: 60px 0;
  .news-list {
    margin-top: 40px;
    display: flex;
    .item {
      flex: 1;
      margin-left: 30px;
      background: #ffffff;
      box-shadow: 0px 6px 18px 0px rgba(51, 51, 51, 0.06);
      border-radius: 2px;
      padding-bottom: 15px;
      &:first-child {
        margin-left: 0;
      }
      &.list {
        padding-bottom: 0;
        display: flex;
        flex-direction: column;
        .item-content {
          border-top: 1px solid #f7f7f7;
          &:first-child {
            border: none;
          }
          p {
            margin-top: 10px;
            height: 3.4em;
            @include clamp(2);
          }
        }
      }
      .image {
        display: block;
        width: 100%;
        height: 300px;
        object-fit: cover;
        transition: all 0.5s;
        &:hover {
          transform: scale(1.02);
        }
      }
      .item-content {
        padding: 20px;
        font-size: 14px;
        color: #333333;
        line-height: 1;
        cursor: pointer;
        &:hover {
          .name {
            text-decoration: underline;
            color: $main-color;
          }
        }
        .name {
          font-size: 18px;
          font-weight: bold;
          @include clamp(1);
        }
        .time {
          margin-top: 10px;
        }
        p {
          line-height: 1.7;
          margin-top: 20px;
          height: 5.1em;
          @include clamp(3);
        }
        .btn {
          display: inline-block;
          line-height: 24px;
          margin-top: 50px;
          padding-right: 25px;
          background: url(../../../assets/images/home/arrow.png) right center
            no-repeat;
          background-size: 19px;
          cursor: pointer;
          &:hover {
            font-size: 15px;
            text-decoration: underline;
          }
        }
      }
    }
  }
}
.isMobile {
  .news-warpper {
    padding: 30px 0;
    .news-list {
      margin-top: 20px;
      .item {
        margin-left: 15px;
        background: #ffffff;
        box-shadow: 0px 4px 12px 0px rgba(51, 51, 51, 0.06);
        padding-bottom: 9px;
        &:first-child {
          margin-left: 0;
        }
        .image {
          height: 180px;
        }
        .item-content {
          padding: 16px;
          .name {
            font-size: 15px;
          }
          p {
            margin-top: 15px;
          }
        }
      }
    }
  }
}
</style>
